
import '@/assets/scss/index.scss'

import _ from 'lodash'
import { convertFilters, searchQueryType, searchResultSortType, keepAllCategory } from '@/feature/search'
import { commonfunc } from '~/mixin/common'
import { formatter } from '~/mixin/fomatter.js'
import { listingTag } from '~/utils/criteo'

import RankCtgr from '~/components/ds/dsa/rankCtgr.vue'
import ProdFilter from '@/components/ds/common/filter/ProdFilter.vue' // 상품 필터
import ProdUnit from '@/components/ds/common/ProdUnitCmp.vue'
import InfiniteScroll from '@/components/common/scroll/InfiniteScroll.vue'
import ProdSwiperCmp from '~/components/ds/common/ProdSwiperCmp.vue'
import ProductSkeleton from '~/components/ds/skeletonUnit/ProductSkeleton.vue'
import NoData from '~/components/common/template/NoData.vue'
import TotalCount from '~/components/common/sort/TotalCount.vue'

export default {
  name: 'DSLIST',
  components: { NoData, TotalCount, ProdSwiperCmp, RankCtgr, ProdFilter, ProdUnit, InfiniteScroll, ProductSkeleton },
  mixins: [formatter, commonfunc],
  props: {
    ctgrNo: { // 카테고리 ID (대/중/소 카테고리 코너에서 사용)
      type: String,
      default: ''
    },
    showCate: { // 전시 카테고리 노출 유무: true(노출) / false(비노출)
      type: Boolean,
      default: true
    },
    showTitle: { // title 노출 유무: true(노출) / false(비노출)
      type: Boolean,
      default: true
    },
    showCtTitle: { // title 노출 유무: true(노출) / false(비노출) (대카테고리 코너에서 사용)
      type: Boolean,
      default: false
    },
    showBtn: { // 필터 버튼 노출 유무: true(노출) / false(비노출) (메인 코너 사용)
      type: Boolean,
      default: true
    },
    brndId: { // 브랜드모아보기에서 호출시 필요한 브랜드코드
      type: String,
      default: ''
    },
    bnnrId: {
      type: String,
      default: ''
    },
    div3: { // 리스트 타입
      type: Boolean,
      default: false
    },
    div4: { // 리스트 타입
      type: Boolean,
      default: false
    },
    div5: { // 리스트 타입
      type: Boolean,
      default: false
    },
    searchTerm: { // 검색화면에서 넘어오는경우
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    },
    applySticky: {
      type: Boolean,
      default: true
    },
    selMidCtg: {
      type: String,
      default: ''
    },
    brndNm: { // 브랜드명
      type: String,
      default: ''
    },
    clickedActiveCategory: { // 타 페이지에서 선택해서 넘어온 카테고리
      type: Object,
      default: () => {
        return {}
      }
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    originProdSize: {
      type: Number,
      default: 0
    },
    quickYn: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      baseUrl: process.env.API_SSN_BASE_URL2,
      groupResult: [],
      reqData: { // 검색솔루션 리퀘스트 파라미터
        searchTerm: '',
        // searchQuery: searchQueryType.Q1, // Q1 : 상품검색 (더보기용)
        searchQuery: this.pageType === 'quickOrder' ? searchQueryType.R27 : searchQueryType.Q1,
        pageNum: 1,
        brndCd: '',
        cntPerPage: 19,
        userId: this.$store.getters['session/getMb'].mbEid ? this.$store.getters['session/getMb'].mbEid : '',
        newPdYn: this.pageType === 'new' ? 'Y' : '',
        massOrPsblYn: this.pageType === 'bulkOrder' ? 'Y' : '',
        pkupOrPsblYn: this.pageType === 'pickupOrder' ? 'Y' : '',
        fdrmOrPsblYn: this.pageType === 'regDel' ? 'Y' : '',
        quickOrPsblYn: this.pageType === 'quickOrder' ? 'Y' : '',
        searchSort: this.pageType === 'home' ? searchResultSortType.inct : (this.pageType === 'new' || this.selMidCtg === 'new' ? searchResultSortType.newp : searchResultSortType.DEFAULT)
      },
      pageNum: 1,
      select1: '추천순',
      options1: [{
        value: this.pageType === 'home' ? searchResultSortType.inct : searchResultSortType.DEFAULT,
        label: '추천순'
      },
      {
        value: searchResultSortType.newp,
        label: '신상품순'
      },
      {
        value: searchResultSortType.order,
        label: '판매량순'
      },
      {
        value: searchResultSortType.revw,
        label: '리뷰많은순'
      },
      {
        value: searchResultSortType.like,
        label: '좋아요순'
      },
      {
        value: searchResultSortType.highPrc,
        label: '가격높은순'
      },
      {
        value: searchResultSortType.lowPrc,
        label: '가격낮은순'
      }
      ],

      select2: '신상품순',
      options2: [
        {
          value: searchResultSortType.DEFAULT,
          label: '추천순'
        },
        {
          value: searchResultSortType.newp,
          label: '신상품순'
        },
        {
          value: searchResultSortType.order,
          label: '판매량순'
        },
        {
          value: searchResultSortType.revw,
          label: '리뷰많은순'
        },
        {
          value: searchResultSortType.like,
          label: '좋아요순'
        },
        {
          value: searchResultSortType.highPrc,
          label: '가격높은순'
        },
        {
          value: searchResultSortType.lowPrc,
          label: '가격낮은순'
        }
      ],

      isLoading: false,
      isMinProdLoading: false,
      resdataList: [],
      displayList: [],
      bannerList: [],

      totalSize: 0,
      badge: {},
      mbEid: this.$store.getters['session/getMbEid'],
      mb: this.$store.getters['session/getMb'],
      showingTabList: [],
      fdrmOrPsblYn: '',
      massOrPsblYn: '',
      quickOrPsblYn: '',
      pkupOrPsblYn: '',
      isListShow: true,
      isScrollable: true,
      recmdProdSwiperOpt: {
        pagination: false,
        slidesPerView: 4,
      },
      exhSmallCtgrNo: '',
      exhSmallCtgrNm: '',
      exceptPdNoList: '',
      minProdSearchTerm: '',

      minProd1List: [], // 소수상품 추천구좌 : 다른 ${소카테고리명} 을 추천해요
      minProd2List: [], // 소수상품 추천구좌 : 이런 상품은 어때요?

      checkedFilter: [],

      firstInitOnPopstate: true,
      firstMinInitOnPopstate: true,
      skeletonCount: 19,
      isInitialLoading: false,
      cachedProductList: [],
    }
  },

  computed: {
    showCtNm () {
      const dynamicId = this.$store.getters['ds/getDynamicId']
      return dynamicId === undefined || dynamicId.lgCtgrNo
    },
    useCachePage () {
      return this.pageType === 'prodSearch' || this.pageType === 'new' || this.pageType === 'bulkOrder' || this.pageType === 'quickOrder' || this.pageType === 'pickupOrder'
    },
    filterCacheKey () {
      const dynamicId = this.$store.getters['ds/getDynamicId']
      const queryString = Object.entries(dynamicId)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
      return this.pageType === 'prodSearch'
        ? '/SearchGoods?searchTerm=' + encodeURIComponent(this.$route.query.searchTerm.toString())
        : this.pageType === 'new' || this.pageType === 'bulkOrder' || this.pageType === 'quickOrder' || this.pageType === 'pickupOrder' ? queryString : ''
    }
  },
  watch: {
    // orderTyp () {
    //   this.searchParam.pageNum = 1
    //   this.isLoading = false
    //   this.minProd2Search()
    // }
  },
  async created () {
    // store에서 대카테고리명 return
    const storeCtNm = await this.$store.dispatch('ds/fetchLgCtgrData')
    if (storeCtNm === undefined || storeCtNm === '') {
      this.storeCtNm = '전체'
    } else {
      this.storeCtNm = storeCtNm
    }
    this.setShowingTabList()
    this.firstInitOnPopstate = !!this.isPopState
    this.firstMinInitOnPopstate = !!this.isPopState
  },
  async mounted () {
    if (this.useCachePage) {
      await this.getCachedSearchResult()
    }
    await this.selectItemBnn()
    await this.searchTotal('', true)

    this.fdrmOrPsblYn = this.$store.getters['ds/getDynamicId'].fdrmOrPsblYn
    this.massOrPsblYn = this.$store.getters['ds/getDynamicId'].massOrPsblYn
    this.quickOrPsblYn = this.$store.getters['ds/getDynamicId'].quickOrPsblYn
    this.pkupOrPsblYn = this.$store.getters['ds/getDynamicId'].pkupOrPsblYn

    // Criteo 파라미터 세팅
    if (this.breadcrumbs.length > 0) {
      let category = ''
      this.breadcrumbs.forEach((item) => {
        category += item.text + '>'
      })
      category = category.slice(0, -1)

      const tagItem = {
        prodList: this.displayList,
        email: '',
        category: category ?? ''
      }

      listingTag(tagItem)
    }
    sessionStorage.setItem('originTotalSize', this.totalSize)
    if (this.totalSize > 0 && this.totalSize < 9) {
      await this.minProd1Search()
      await this.minProd2Search()
    }
  },
  methods: {
    resetReqData () {
      this.prodList = []
      this.resdataList = []
      this.displayList = []

      this.searchQuery = searchQueryType.Q1
      this.isLoading = false
      this.reqData.pageNum = 1
      this.reqData.brndCd = this.brndId !== '' ? '' : this.brndId
      this.reqData.dvrTy = ''
      this.reqData.goodsType = ''
      this.reqData.revwStsc = ''
      this.reqData.pdPrcRange = ''
      this.reqData.tOrdr = ''
    },
    handleFilter (filters, noGroupResult) {
      this.clearCachedResult()
      this.resetReqData()
      this.reqData = _.merge(this.reqData, convertFilters(filters))
      this.searchTotal(this.reqData.searchSort, noGroupResult)
    },
    testSearch () {
      this.searchTotal('scroll', true)
    },
    async searchTotal (searchSort, withGroupResult) {
      if (this.isLoading) {
        return
      }
      if (this.pageType === 'new') {
        this.reqData.searchQuery = searchQueryType.R27
      }
      if (this.pageType === 'home' && this.resdataList.length === 200) { // 배너제외하고 200개까지
        return
      }
      this.isListShow = false
      this.isLoading = true
      // 상세페이지 이동 후 복귀 시 필터 고정 적용
      const filters = sessionStorage.getItem('filterCheck')
      if (filters !== null && filters !== '') {
        this.checkedFilter = JSON.parse(filters)
      }
      if (this.checkedFilter != null && this.checkedFilter.length > 0) {
        this.reqData = _.merge(this.reqData, convertFilters(this.checkedFilter))
      }
      // 상세페이지 이동 후 복귀 시 정렬 고정 적용
      const sorts = sessionStorage.getItem('prodSortCheck')
      if (sorts !== null && sorts !== '') {
        this.reqData.searchSort = sorts
        if (sorts === 'new') {
          this.select1 = '신상품순'
        } else if (sorts === 'order') {
          this.select1 = '판매량순'
        } else if (sorts === 'revw') {
          this.select1 = '리뷰많은순'
        } else if (sorts === 'like') {
          this.select1 = '좋아요순'
        } else if (sorts === 'highPrc') {
          this.select1 = '가격높은순'
        } else if (sorts === 'lowPrc') {
          this.select1 = '가격낮은순'
        }
        this.select2 = this.select1
      }

      // 브랜드모아보기페이지
      if (this.isNotEmpty(this.brndId)) {
        this.reqData.brndCd = this.brndId
        this.reqData.searchQuery = searchQueryType.R13
      }

      /// 홈메인 상품 더보기인 경우
      if (this.pageType === 'home') {
        this.reqData.searchQuery = searchQueryType.R22
        //   this.reqData.searchSort = !this.isNotEmpty(searchSort) ? 'inct' : searchSort
        this.reqData.soldOutYn = 'N'
      }

      // 대/중/소카테고리 페이지인 경우에는 dynamicId가 아닌 props로 받은 this.ctgrNo를 넘겨야 함
      if (this.ctgrNo !== '') {
        this.reqData.exhCtgrNo = this.ctgrNo
        // this.setReqData()
      }

      // 검색화면에서 넘어오는 경우
      if (this.searchTerm !== '') {
        this.reqData.searchTerm = this.searchTerm
      }
      const dynamicId = this.$store.getters['ds/getDynamicId']
      if (dynamicId && this.pageType !== 'brand' && this.pageType !== 'prodSearch') {
        // dynamicId의 key와 value를 동적으로 this.reqData에 추가
        for (const key in dynamicId) {
          // this.reqData.exhCtgrNo = dynamicId[key]
          // if (key !== 'lgCtgrNo') {
          this.reqData[key] = dynamicId[key]
          // }
        }

        if (this.reqData.exhCtgrNo === 'Y' || this.reqData.exhCtgrNo === 'N') {
          this.reqData.exhCtgrNo = ''
        }
      }
      if (dynamicId.pkupOrPsblYn === 'Y') {
        this.reqData.searchQuery = 'R28'
      }
      try {
        if (this.bannerList.length < 1 || this.bannerList.length <= (this.reqData.pageNum - 1)) { // 배너가 한건도 조회되지 않았거나 더이상 리스트에 쌓을 배너가 없을 경우, DEV-549
          this.reqData.cntPerPage = 20 // 배너 없이 20건 조회
        }
        const reqSearchUrl = '/SearchGoods'
        let res = await this.$AxiosBuilderCache
          .params(this.reqData)
          .baseURL(this.baseUrl)
          .build()
          .get(reqSearchUrl)
          .then((res) => {
            return res.data
          })
          .catch((err) => {
            console.log(err)
          })
        if (res.resultSet.result[1].totalSize === 0) {
          res = await this.$AxiosBuilder
            .params(this.reqData)
            .baseURL(this.baseUrl)
            .build()
            .get(reqSearchUrl)
            .then((res) => {
              return res.data
            })
            .catch((err) => {
              console.log(err)
            })
        }
        this.$airbridge.viewSearchResult(this.reqData.searchTerm) // [DEV-5544] 에어브릿지 - 검색 관련 이벤트 적용
        let testList = []
        testList = res.resultSet.result[1].resultDocuments

        this.totalSize = res.resultSet.result[1].totalSize

        if (this.pageType === 'brand' && this.reqData.pageNum === 1) {
          this.$emit('getBrandItemTotal', this.totalSize)
        }

        if (this.reqData.pageNum === 1) {
          this.isInitialLoading = true
          console.log('배너호출')
          await this.selectItemBnn()
        }

        if (withGroupResult) {
          this.groupResult = keepAllCategory(
            this.groupResult,
            res.resultSet.result[0].groupResult
          )
        }
        // 뒤로가기로 왔을 때는 캐시 된 데이터를 로드
        if (this.firstInitOnPopstate && this.cachedProductList.length > 0 && this.useCachePage) {
          this.displayList = []
          this.displayList.push(...this.cachedProductList)
          this.cachedProductList = []
        } else {
          _.flatMap(testList, (item, index) => {
            const result = { ...item, banner: 'N' }
            if (this.resdataList.length < 200 && this.pageType === 'home') {
              this.resdataList.push(result)
              this.displayList.push(result)
            }

            if (this.pageType !== 'home') {
              this.displayList.push(result)
            }
          })
          //  console.table('lodsh  this.displayList 테스트', this.displayList)
          //   20번째에 배너 넣기,상품이 기본 노출 갯수보다 적으면 배너 노출 안함
          if (testList.length === 19 && this.bannerList.length > (this.reqData.pageNum - 1)) {
            this.displayList.push(this.bannerList[this.reqData.pageNum - 1])
          }
        }

        if (res.resultSet.result[1].realSize > 0) {
          this.reqData.pageNum += 1
          this.isLoading = false
          this.firstInitOnPopstate = false
          this.isInitialLoading = false
        }

        // 소수상품 추천구좌 파라미터 세팅
        if (this.totalSize > 0 && this.totalSize < 9) {
          const firstProd = res.resultSet.result[1].resultDocuments[0]
          this.exhSmallCtgrNo = firstProd.exhSmallCtgrNo
          this.exhSmallCtgrNm = firstProd.exhSmallCtgrNm
          res.resultSet.result[1].resultDocuments.forEach((item) => {
            this.exceptPdNoList += item.pdNo + ','
          })
          this.minProdSearchTerm = this.searchTerm
          if (this.totalSize === 1) {
            this.minProdSearchTerm = firstProd.pdNm
          }
        }

      // console.log('============================================================')
      //  console.log(this.displayList.length, this.isListShow, this.showBtn)
      //   console.log('============================================================')
      } catch (err) {
        console.log(err)
      } finally {
        this.isListShow = true
        this.$store.commit('page/setPopstate', false)
      }
    },
    async minProd1Search () {
      const params = {
        pageNum: 1,
        cntPerPage: 12,
        searchQuery: 'R11',
        exhCtgrNo: this.exhSmallCtgrNo,
        pdNo: this.exceptPdNoList
      }
      this.minProd1List = await this.$AxiosBuilder
        .params(params)
        .baseURL(this.baseUrl)
        .build()
        .get('/GoodsCategorySmall')
        .then((res) => {
          const result = res.data.resultSet.result[res.data.resultSet.result.length - 1].resultDocuments
          return result
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async minProd2Search () {
      if (this.isMinProdLoading) {
        return
      }
      this.isMinProdLoading = true
      const params = {
        mumm: 'Y',
        exhSmallCtgrNo: this.exhSmallCtgrNo,
        pdNo: this.exceptPdNoList,
        searchTerm: this.minProdSearchTerm,
        pageNum: this.pageNum,
        cntPerPage: 12
      }
      let realSize = 0
      const resultList = await this.$AxiosBuilder
        .params(params)
        .baseURL(this.baseUrl)
        .build()
        .get('/GoodsMummResult')
        .then((res) => {
          realSize = res.data.resultSet.result[res.data.resultSet.result.length - 1].realSize
          const result = res.data.resultSet.result[res.data.resultSet.result.length - 1].resultDocuments
          return result
        })
        .catch((err) => {
          this.isMinProdLoading = false
          console.log(err)
        })
      this.minProd2List.push(...resultList)

      if (realSize > 0) {
        this.pageNum += 1
        this.isMinProdLoading = false
        this.firstMinInitOnPopstate = false
        this.$store.commit('page/setPopstate', false)
      }
    },
    async selectItemBnn () { // 상품 더보기 배너 가져오기
      // '2023092602': bnnrId가 없는 경우 대비 만들어둠
      const paramdata = {
        exhCmptmtId: this.bnnrId ? this.bnnrId : '2023092602',
        exhMtrlNo: '1', // 상단 카테고리 제거하기로 해서 구좌에 등록된 배너 노출
        exhCtgrNo: this.reqData.exhCtgrNo
      }
      console.log('paramdata', paramdata)
      await this.$AxiosBuilder
        .data(paramdata)
        .build()
        .post('/ds/exh/selBanr')
        .then((res) => {
          const resList = res.data.data.details

          resList.forEach((item, i) => {
            const newItem = Object.assign({}, {
              pcomIconAtchFileUrl: item.pcomIconAtchFileUrl,
              banrRplcTextNm: item.banrRplcTextNm,
              banner: 'Banner',
              id: i,
              pcomLinkUrl: item.pcomLinkUrl
            })
            this.bannerList.push(newItem)
          })
        }).catch((err) => {
          console.log(err)
        })
    },

    setReqData (largeExhCtgrNo) {
      if (largeExhCtgrNo) { this.reqData.exhCtgrNo = largeExhCtgrNo }

      if (this.ctgrNo !== '') {
        // 대/중/소카테고리 페이지 관련 세팅
        this.reqData.exhCtgrNo = this.ctgrNo
      } else if (!largeExhCtgrNo) {
        // 전시카테고리 컴포넌트 페이지 관련 세팅
        this.reqData.exhCtgrNo = largeExhCtgrNo
      }
      this.reqData.pageNum = 1
    },
    goRcmdProdAll () {
      const recmdPageParam = {
        searchApi: {
          exhCtgrNo: this.exhSmallCtgrNo,
          pdNo: this.exceptPdNoList,
          searchQuery: 'R11'
        },
        exhCmptmtInfo: {
          hdcpy: '다른 ' + this.exhSmallCtgrNm + ' 상품을 추천해요',
          lginYn: 'N',
          exhMtrlRgMthdCd: '20', // 구좌 리스트 조회(10 : 전시파트 수기등록, 20 : 검색솔루션, 30: 추천솔루션)
          insdYn: 'N', // api 구분(Y : 전시파트 수기등록 or 추천솔루션, N : 검색솔루션)
          url: process.env.API_SSN_BASE_URL2 + '/GoodsCategorySmall'
        }
      }
      this.$store.dispatch('ds/persisted/updateRendingSet', recmdPageParam).then(() => {
        this.$router.push({ name: 'ds-recmd-id', params: { id: 'C206' } })
      })
      sessionStorage.setItem('preFilterCheck', sessionStorage.getItem('filterCheck'))
      sessionStorage.setItem('filterCheck', [])
    },
    async callSearchTotal (largeExhCtgrNo) {
    //  console.log('callSearchTotal largeExhCtgrNo ', largeExhCtgrNo)
      await this.clearCachedResult()
      if (this.firstInitOnPopstate && this.useCachePage) {
        return false
      }

      this.isLoading = false
      // totalSearch param셋팅
      this.setReqData(largeExhCtgrNo)
      this.displayList = []
      this.bannerList = []
      this.resdataList = []

      // 카테 클릭시 필터 초기화
      if (this.showBtn) {
        this.$refs.filter.resetFilterChecked()
      }
      // totalSearch 수행
      // 홈메인 Q1->R22로 변경하면서 수정
      //  await this.selectItemBnn()
      this.searchTotal(this.reqData.searchSort)

      const scrollArea = window
      // scrollArea.scrollTo({ top: 0, behavior: 'smooth' })
      //  const ctgrHeight = document.getElementsByClassName('prod-category')[0].clientHeight
      if (this.ctgrNo !== '') {
        scrollArea.scrollTo({ top: this.$refs.rankCtgr.parentElement.offsetTop, behavior: 'smooth' })
      }
    },

    async getCachedSearchResult () {
      this.cachedProductList = []
      let counter = 0

      const savedData = await this.$AxiosBuilderCache.fetchCachedResults(this.filterCacheKey)
      if (savedData !== null) {
        await this.selectItemBnn()
        _.flatMap(savedData?.data, (item, index) => {
          const result = { ...item, banner: 'N' }
          this.cachedProductList.push(result)
          if (index > 0 && (index + 1) % 19 === 0 && this.bannerList.length > 0) {
            this.cachedProductList.push(this.bannerList[counter])
            counter = (counter + 1) % 4
          }
        })
        if (this.isPopState) {
          this.getCachedSearchParam(savedData)
        } else {
          await this.clearCachedResult()
        }
      } else {
        return false
      }
    },
    getCachedSearchParam (savedData) {
      const savedParam = new URL(savedData?.lastKey)
      const params = Object.fromEntries(savedParam.searchParams.entries())
      Object.keys(params).forEach((key) => {
        if (!isNaN(Number(params[key])) && params[key] !== '') {
          params[key] = Number(params[key])
        }
      })
      if (params) {
        this.reqData = params
        this.select1 = params.searchSort
      }
    },
    async clearCachedResult () {
      if (this.useCachePage && !this.firstInitOnPopstate) {
        await this.$AxiosBuilderCache.clearCachedSearchResults(this.filterCacheKey)
      }
    },

    setflag (str) {
      if (str === 'Y' || str === '02') { return true } else { return false }
    },

    setPrice (str) {
      return Number(str.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
    },

    setReviewCnt (cnt) {
      if (Number(cnt.replace(/[^0-9]/g, '')) > 9999) {
        return '+9,999'
      } else {
        return Number(cnt.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },

    setTotal (cnt) {
      if (Number(cnt.replace(/[^0-9]/g, '')) > 99999) {
        return '+99,999'
      } else {
        return Number(cnt.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },

    async sortChange (e) {
      await this.clearCachedResult()
      const changeValue = e

      this.reqData.searchSort = changeValue
      this.resdataList = []
      this.displayList = []
      this.reqData.pageNum = 1
      this.isLoading = false
      sessionStorage.setItem('prodSortCheck', changeValue)
      this.searchTotal(this.reqData.searchSort)
    },
    setShowingTabList () {
      if (this.pageType === 'brand') { // 브랜드모아보기
        this.showingTabList = ['배송유형', '상품유형', '별점', '가격대']
      } else if (this.pageType === 'lgCtgr' || this.pageType === 'home') { // 대카나 홈
        this.showingTabList = ['브랜드별', '배송유형', '상품유형', '별점', '가격대']
      } else if (this.pageType === 'msCtgr') { // 중소카  나중에 상품 속성
        this.showingTabList = ['속성', '브랜드별', '배송유형', '상품유형', '별점', '가격대']
      } else if (this.pageType === 'regDel' || this.pageType === 'bulkOrder' || this.pageType === 'pickupOrder') { // 정기 배송, 대량주문, 매장픽업
        this.showingTabList = ['브랜드별', '상품유형', '별점', '가격대']
      } else if (this.pageType === 'prodSearch') { // 상품검색 나중에 속성
        this.showingTabList = ['카테고리', '브랜드별', '배송유형', '상품유형', '별점', '가격대']
      } else if (this.pageType === 'new') { // 신상
        this.showingTabList = ['브랜드별', '배송유형', '상품유형', '별점', '가격대']
      } else if (this.pageType === 'quickOrder') { // 신상
        this.showingTabList = ['브랜드별', '별점', '가격대']
      }
    },
    isShowProperty () {
      // 소카 레벨에서만, CTGR_ 3개
      return _.chain(this.$route.path)
        .split('/')
        .filter(item => _.startsWith(item, 'CTGR_'))
        .size()
        .value() === 3
    },
    isGiftCardDisable () {
      if(['new','bulkOrder','pickupOrder','quickOrder'].includes(this.pageType)) {
        return true
      } else {
        return false
      }
    }
  }
}
